import './App.css';
import Home from './app/Home';
import './app/style.css'
function App() {
  return (
    <div className="App">
      <Home></Home>
    </div>
  );
}

export default App;
